export default {
  INTERNAL_ORDERS: "Commandes internes",
  ESTABLISHMENT_INTERNAL_ORDERS_LIST: "Liste des commandes internes",
  ADD_ESTABLISHMENT_INTERNAL_ORDER: "Ajouter une commande interne",
  ESTABLISHMENT_INTERNAL_ORDER_ADDED: "Commande interne ajoutée",
  EDIT_ESTABLISHMENT_INTERNAL_ORDER: "Modifier une commande interne",
  ESTABLISHMENT_INTERNAL_ORDER_UPDATED: "Commande interne mise à jour",
  VIEW_ESTABLISHMENT_INTERNAL_ORDER: "Voir la commande interne",
  DELETE_ESTABLISHMENT_INTERNAL_ORDER: "Supprimer la commande interne",
  DELETE_THIS_ESTABLISHMENT_INTERNAL_ORDER: "Supprimer cette commande interne ?",
  ESTABLISHMENT_INTERNAL_ORDER_DELETED: "Commande interne supprimée",

  STATUS_DRAFT: "Brouillon",
  STATUS_SUBMITTED: "Soumise",
  STATUS_CONFIRMED: "Confirmée",
  STATUS_PARTIALLY_INVOICED: "Partiellement facturée",
  STATUS_COMPLETED: "Complétée",
  STATUS_REJECTED: "Rejetée",
  STATUS_CANCELED: "Annulée",

  INVOICING_STATUS_PENDING: "À facturer",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partiellement facturée",
  INVOICING_STATUS_INVOICED: "Facturée",
  INVOICING_STATUS: "Avancement de la facturation",

  WEEK: "Semaine",
  WEEK_STARTS_AT: "Début de la semaine (lundi)",
  WEEK_ENDS_AT: "Fin de la semaine (vendredi)",
  PRODUCTION_ESTABLISHMENT: "Établissement de production",
  SATELLITE_ESTABLISHMENT: "Établissement satellite",
  PRODUCTION_CAFETERIA: "Cafétéria de production",
  SATELLITE_CAFETERIA: "Cafétéria satellite",

  SUBMIT: "Valider et soumettre",
  SUBMIT_QUESTION: "Soumettre la commande interne à l'établissement de production ?",
  CONFIRM: "Confirmer",
  CONFIRM_QUESTION: "Confirmer cette commande interne ?",
  CONFIRM_FREEZE_HINT: "La commande sera figée.",
  ESTABLISHMENT_INTERNAL_ORDER_SUBMITTED: "Commande interne soumise",
  ESTABLISHMENT_INTERNAL_ORDER_CONFIRMED: "Commande interne confirmée",
  REJECT: "Rejeter",
  REJECT_QUESTION: "Rejeter cette commande interne ?",
  ESTABLISHMENT_INTERNAL_ORDER_REJECTED: "Commande interne rejetée",
  CANCEL_QUESTION: "Annuler cette commande interne ?",
  ESTABLISHMENT_INTERNAL_ORDER_CANCELED: "Commande interne annulée",
  REVERT_TO_DRAFT_QUESTION: "Remettre la commande interne en brouillon ?",
  ESTABLISHMENT_INTERNAL_ORDER_REVERTED: "Commande interne remise en brouillon",
  ADD_ITEMS_FIRST: "Saisissez au moins une quantité avant de soumettre.",
  SUBMITTED_BY: "Soumise par",
  SUBMITTED_AT: "Soumise le",
  CONFIRMED_BY: "Confirmée par",
  CONFIRMED_AT: "Confirmée le",

  ITEMS_GRID: "Grille de la semaine",
  COPY_MONDAY_TO_WEEK: "Copier lundi sur toute la semaine",
  COPY_MONDAY_TO_WEEK_DONE: "Quantités du lundi copiées sur la semaine",
  DUPLICATE_PREVIOUS_WEEK: "Reprendre la semaine précédente",
  DUPLICATE_PREVIOUS_WEEK_DONE: "Quantités de la semaine précédente reprises",
  NO_PREVIOUS_WEEK: "Aucune commande interne trouvée pour la semaine précédente",
  TOTAL_QUANTITY: "Qté totale",
  DAY_TOTAL: "Total du jour",
  WEEK_TOTAL: "Total de la semaine",

  TRACKING: "Suivi",
  ORDERED: "Commandé",
  INVOICED: "Facturé",
  REMAINING: "Reste à facturer",
  LINE_STATE_CONFORM: "Conforme",
  LINE_STATE_PARTIAL: "Partiel",
  LINE_STATE_NOT_RECEIVED: "Non reçu",
  LINE_STATE_OVER: "Sur-reçu",

  INTERNAL_INVOICES: "Factures internes",
  GENERATE_INVOICE_FOR_DAY: "Générer et soumettre la facture du {day}",
  INVOICE_GENERATED: "Facture interne générée et soumise pour acceptation",
  DAY_FULLY_INVOICED: "Journée facturée",
  DAY_NOT_RECEIVED: "Journée non reçue",
  NOTHING_LEFT_TO_INVOICE: "Plus rien à facturer pour cette journée",

  DAILY_PREPARATIONS: "Préparations du jour",
  DAILY_PREPARATIONS_LIST: "Préparations du jour",
  DAILY_PREPARATIONS_HELP:
    "Ce que la production doit fabriquer et envoyer aujourd'hui. Écran de lecture : la facture interne est saisie par l'établissement qui reçoit.",
  PRINT_SENDING_SLIP: "Bordereau d'envoi du jour",
  PRINT_WEEK: "Imprimer la semaine",
  AGGREGATED_BY_PRODUCT: "Total par produit, toutes cafétérias satellites",
  NO_PREPARATION_FOR_DAY: "Aucune préparation pour cette journée",
  PRODUCTIONS_TO_MAKE: "Productions à faire",
  PREPARATIONS_PERIOD: "Période",
  PRINT_PRODUCTION_LIST: "Imprimer la liste",
  CHOOSE_PRODUCTION_ESTABLISHMENT: "Choisissez l'établissement producteur pour afficher ses productions à faire.",
  WEEKLY_PREPARATIONS_HELP:
    "Ce que la production doit fabriquer et envoyer chaque jour de la semaine, toutes cafétérias satellites confondues. Écran de lecture : la facture interne est saisie par l'établissement qui reçoit.",
  WEEK_FROM_TO: "Semaine du {from} au {to}",
  NO_PREPARATION_FOR_WEEK: "Aucune préparation pour cette semaine",
  NOTHING_TO_PRODUCE_TODAY: "Rien à produire aujourd'hui.",
  SEE_TODAY: "Voir la journée",
  SEE_WEEK: "Voir la semaine",
  ORDERS_TO_CONFIRM: "Commandes internes à confirmer",
  TO_PRODUCE_TODAY: "À produire et envoyer aujourd'hui",
  REVERT_TO_DRAFT: "Remettre en brouillon",
  LINES: "Lignes",
  ESTABLISHMENT_TAB_HELP: "Cette liste contient les commandes internes de l'établissement, qu'il soit à la source (production) ou à la destination (satellite).",
  ADD_FROM_ESTABLISHMENT_HELP: "{establishment} est l'établissement qui commande (satellite). Choisissez son établissement de production.",
  ESTABLISHMENT_NOT_SATELLITE: "{establishment} n'a aucune cafétéria de type « Satellite » : pour passer des commandes internes, cet établissement doit héberger une cafétéria satellite. Vous pouvez tout de même créer une commande, mais vérifiez d'abord la configuration des cafétérias.",
  ESTABLISHMENT_NOT_PRODUCTION: "{establishment} n'a aucune cafétéria de type « Production » : il ne peut donc pas être choisi comme établissement de production dans une commande interne d'un autre établissement.",
  NO_SATELLITE_CAFETERIA_WARNING: "Cet établissement n'a aucune cafétéria de type « Satellite ». Normalement, seul un établissement avec une cafétéria satellite passe des commandes internes. La création reste possible.",
  NO_PRODUCTION_ESTABLISHMENT_WARNING: "Aucun établissement avec une cafétéria de type « Production » n'a été trouvé. Configurez une cafétéria de production avant de créer des commandes internes.",
  SEND_BY_MAIL: "Envoyer par courriel",
  SEND_NOW_QUESTION: "Envoyer la commande interne maintenant ?",
  SEND_NOW_HINT: "Vous pouvez envoyer la commande à l'établissement de production dès maintenant pour éviter les oublis.",
  MAIL_SENT_AT: "Envoyée le",
  MAIL_SENT_BY: "Envoyée par",
  CONFIRM_BEFORE_INVOICING: "Confirmez la commande pour pouvoir facturer",
  DISCOUNT: "Rabais",
  AUTHOR_CANNOT_DECIDE: "Vous avez créé ou soumis cette commande : sa confirmation ou son rejet revient à l'établissement de production.",
  PRODUCTION_HAS_NO_WAREHOUSE: "Aucun entrepôt n'est rattaché à l'établissement de production : impossible de lister les produits commandables. Rattachez un entrepôt à cet établissement.",
  RECEIVED: "Reçu",
  GENERATE_INVOICE: "Générer et soumettre",
  DECLARE_NOT_RECEIVED: "Déclarer la journée non reçue",
  NOT_RECEIVED_HINT:
    "Toutes les quantités sont à 0 : la journée sera déclarée non reçue. Une facture à 0 $ la clôturera, et l'établissement de production l'acceptera après avoir pris connaissance du motif.",
  GENERATE_INVOICE_MODAL_HELP: "Ajustez les quantités reçues : la facture interne sera générée puis soumise immédiatement pour acceptation. Elles sont préremplies avec ce qu'il reste à facturer pour cette journée ; mettez 0 sur une ligne non reçue. La facture sera datée sur cette journée commandée, quel que soit le jour où vous la générez.",
  OVER_RECEPTION_HINT: "Une quantité saisie dépasse le reste à facturer : la ligne sera marquée « sur-reçu » dans le suivi.",
  VIEW_INTERNAL_ORDER: "Voir la commande interne",
  INTERNAL_ORDERS_MENU: "Commande interne",
  TRACKING_WIDGET_TITLE: "Suivi des commandes internes",
  TRACKING_WIDGET_TO_PROCESS: "À traiter — côté production",
  TRACKING_WIDGET_IN_PROGRESS: "En cours — côté satellite",
  REMAINING_DAYS: "Journées à facturer",
};
